<div class="c-modal__inner">
  <form class="c-form c-form--d" (ngSubmit)="submit()" [formGroup]="form">
    <div class="c-modal__head">
      <div class="c-modal__close" (click)="close()">
        <p500-ui-icon name="close" size="20px"></p500-ui-icon>
      </div>
      <div class="c-modal__title">{{ title }}</div>
      <div *ngIf="name" class="c-modal__subtitle"><span i18n="@@settings.preset_name">Preset Name</span>: {{ name }}</div>
      <div class="c-modal__subtitle"></div>
    </div>

    <div class="c-modal__body">
      <div class="row">
        <div class="col-12" *ngIf="!settings || isLoading">
          <p500-ui-cube-preloader></p500-ui-cube-preloader>
        </div>

        <ng-container *ngIf="settings && !isLoading">
          <div class="col-12">
            <p500-ui-text-field [formControl]="form.controls.presetName" i18n-label="@@common.name" label="Name"> </p500-ui-text-field>
          </div>

          <ng-container formGroupName="filters">
            <div class="col-12 mt-10">
              <p500-ui-dropdown class="c-dropdown c-dropdown--tables" position="left">
                <ng-template p500UIDropdownHeader let-isOpen="isOpen" let-toggle="toggle">
                  <div class="c-modal__body-title mt-12" (click)="toggle()">
                    <div class="title d-flex align-items-center">
                      <span i18n="@@common.groups">Groups</span>
                      <button type="button" [hidden]="!hasRelations" p500-ui-button-icon class="ml-10" color="primary">
                        <p500-ui-icon [name]="'plus'"></p500-ui-icon>
                      </button>
                    </div>
                  </div>
                </ng-template>
                <ng-template p500UIDropdownBody>
                  <ng-container *ngFor="let group of filters.controls.groups.value">
                    <ng-container *ngIf="relationMap.has(group.key)">
                      <div p500UIDropdownItem class="c-dropdown__item" (click)="openRelationModal(group.key)">
                        <span class="c-dropdown__item-text d-flex align-items-center">
                          <span>{{ group.label }}</span>
                          <ng-container *ngIf="relationMap.hasActiveRelations(group.key)">
                            <button
                              p500-ui-confluent-button
                              size="small"
                              color="warn"
                              class="ml-5"
                              (click)="clearRelations(group.key); $event.stopPropagation()"
                              i18n="@@common.reset"
                            >
                              Reset
                            </button>
                          </ng-container>
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-template>
              </p500-ui-dropdown>
              <gtd-drag-drop-select formControlName="groups" [data]="groups"> </gtd-drag-drop-select>
            </div>

            <div class="col-12 mt-15">
              <p500-ui-boolean-select-field
                [formControl]="form.controls.add_relation_columns"
                label="Add columns for Relations"
                i18n-label="@@common.add_columns_for_relations"
              >
              </p500-ui-boolean-select-field>
            </div>
            <div class="col-12 mt-15" *ngIf="globalData.available_offer_currencies.length > 1">
              <gtd-currency-select [formControl]="form.controls.currency" [acceptedCurrencyList]="globalData.offer_currencies_options">
              </gtd-currency-select>
            </div>

            <ng-container *ngFor="let filter of filters.controls | keyvalue">
              <div class="col-12 mt-10">
                <div class="c-modal__body-title mt-12">
                  <div class="title">
                    {{ filterLocalization.get(settings.filters[filter.key]?.label) ?? settings.filters[filter.key]?.label }}
                  </div>
                  <div class="actions">
                    <div class="action" *ngIf="settings.filters[filter.key]?.type === 'conditions'">
                      <div (click)="addCondition(filter.key)" class="c-link c-link--primary -blue">
                        <p500-ui-icon name="plus"></p500-ui-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ng-container [ngSwitch]="settings.filters[filter.key]?.type">
                <div *ngSwitchCase="'switchers'" class="col-12">
                  <p500-ui-group-checkbox
                    [checkboxes]="settings.filters[filter.key]?.items"
                    [formControlName]="filter.key"
                    itemsContainerClass="c-form c-form--builder"
                    itemClass="c-form__section"
                  >
                  </p500-ui-group-checkbox>
                </div>

                <div *ngSwitchCase="'conditions'" class="col-12 c-conditions c-conditions--d">
                  <div formArrayName="{{ filter.key }}" class="c-conditions__groups-conditions">
                    <p500-ui-preset-condition
                      *ngFor="let condition of filter.value.controls; let i = index"
                      [index]="i"
                      [formControlName]="i"
                      [name]="filter.key"
                      [conditions]="settings.filters[filter.key]?.items | translateData : 'label' : CONDITIONS_TRANSLATIONS"
                      [getValueComponentByType]="presetHelpers.getValueComponentByType"
                      [getSignsData]="presetHelpers.getSignsData"
                      (remove)="removeCondition(filter.key, $event)"
                      class="c-conditions__condition c-form__section"
                    >
                    </p500-ui-preset-condition>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
          <div class="row col-12">
            <div class="col-md-6 mb-10">
              <gtd-drag-drop-select
                [formControl]="filters.controls.columns"
                bindLabel="label"
                [data]="columnsData"
                label="Columns"
                i18n-label="@@common.columns"
              >
              </gtd-drag-drop-select>
            </div>
            <div class="col-md-6 mb-10">
              <p500-ui-select-field
                [formControl]="form.controls.default_range"
                [data]="dateIntervals"
                label="Date Range"
                i18n-label="@@common.date_range"
              >
              </p500-ui-select-field>
            </div>
          </div>
          <div class="row col-12 mb-20">
            <div class="col-md-6 mb-10">
              <p500-ui-boolean-select-field [formControl]="form.controls.is_flat" label="Flat" i18n-label="@@common.flat">
              </p500-ui-boolean-select-field>
            </div>
            <div class="col-md-6 mb-10">
              <p500-ui-boolean-select-field
                [formControl]="form.controls.show_in_menu"
                label="Show in Menu"
                i18n-label="@@common.show_in_menu"
              >
              </p500-ui-boolean-select-field>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="c-modal__footer c-modal__footer--info">
      <div *ngIf="hash">
        <span class="c-modal__subtitle"><span i18n="@@common.hash">Hash</span>:</span>
        <span> {{ hash }} </span>
      </div>
      <div class="c-modal__actions ml-auto">
        <div class="c-modal__action">
          <button p500-ui-button type="button" [stroked]="true" (click)="close()" i18n="@@common.cancel">Cancel</button>
        </div>

        <div class="c-modal__action">
          <button
            p500-ui-button
            type="submit"
            classIcon="p500-ui-icon-check"
            positionIcon="right"
            i18n="@@common.apply"
            [disabled]="form.invalid || isLoading"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
